import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorScrollService {
  public setScrollError$: Subject<void> = new Subject();

  constructor() {}
}
